module.exports = __webpack_public_path__ + "static/summer-sale-banner-f1f66fafda476d27fea356bf6922f95c.png";